export const CONSTANTS = {
  JWT_COOKIE_NAME: "accessToken",
};
